/* eslint-disable global-require */

export default {
	login: {
		bgColor: '#f9f9f9', // '#FF5000',
		bgImage: require('@/application/assets/images/login-bg.jpg'),
		bgSize: 'cover',
		logo: null // require('@/application/assets/images/logo.png')
	}
};
